import { dashboardv20240509Client } from '@sequencehq/api/dashboard/v20240509'

export const getDefaultUsageMetricForProduct = async (
  productId: string
): Promise<string | undefined> => {
  const prices =
    (
      await dashboardv20240509Client.getListPrices({
        productId
      })
    ).data?.items ?? []

  const firstUsageMetricInListPrices = (
    prices.find(
      price =>
        'usageMetricId' in price.structure && price.structure?.usageMetricId
    )?.structure as { usageMetricId: string } | undefined
  )?.usageMetricId

  return firstUsageMetricInListPrices
}

export const getDefaultSeatMetricForProduct = async (
  productId: string
): Promise<string | undefined> => {
  const prices =
    (
      await dashboardv20240509Client.getListPrices({
        productId
      })
    ).data?.items ?? []

  const firstSeatMetricInListPrices = (
    prices.find(
      price =>
        'seatMetricId' in price.structure && price.structure?.seatMetricId
    )?.structure as { seatMetricId: string } | undefined
  )?.seatMetricId

  return firstSeatMetricInListPrices
}
